














import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
@Component({})
export default class CSlider extends Vue {

  @Prop()
  value!: number

  position: string = this.value * 100 + '%'

  @Watch('value')
  onValueChange(val: number) {
    this.position = val * 100 + '%'
  }

  handleMouseDown(event: any) {
    const sliderBlock: any = this.$refs['slider-block']
    window.addEventListener('touchmove', this.handleMouseMove)
  }

  handleMouseUp(event: any) {
    const sliderBlock: any = this.$refs['slider-block']
    window.removeEventListener('touchmove', this.handleMouseMove)
    window.removeEventListener('touchend', this.handleMouseUp)
  }

  handleMouseMove(event: any) {
    window.addEventListener('touchend', this.handleMouseUp)
    const sliderBlock: any = this.$refs['slider-block']
    const sliderLine: any = this.$refs['slider-line']
    const mouseX = event.touches[0].clientX
    const lineX = sliderLine.getBoundingClientRect().x
    const lineWith = sliderLine.clientWidth
    const blockPosition = (mouseX - lineX) / lineWith
    if (blockPosition >= 0 && blockPosition <= 1) {
      this.position = blockPosition * 100 + '%'
      this.$emit('change', blockPosition)
    }
  }
}
